<template>
  <div class="result">
    <div class="result-cointainer">
      <img :src="error" alt class="result_img" />
      <h3>当前阶段认证失败</h3>
      <h4>你可以点击下方的按钮，重新开始验证。</h4>
    </div>

    <div class="record-btn" @click="handleClick">立即认证</div>
  </div>
</template>
<script>
import error from "@/assets/error.png";
// query:{aId:this.applyId,sId:this.settingId}
export default {
  data() {
    this.error = error;
    return {
      phone: "",
      user_info:{},
      type: 1,
      show: false,
      upload: false,
      img: "",
      registerCode: "",
      password: ""
    };
  },
  methods: {
    handleClick(){
      this.$router.go(-1)
    }
  },
  created(){
  }
};
</script>
<style lang="less" scoped>
.result {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f3f2f1;
  &-cointainer {
    text-align: center;
    padding: 0 14px;
    .result_img {
      margin: 131px 0 25px;
      width: 94px;
      height: 94px;
    }
    > h3 {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #323333;
      margin-bottom: 16px;
    }
    >h4{
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #323333;
    }
    
    .result_info {
      margin-top: 10px;
      height: 40px;
      display: flex;
      padding: 0 12px;
      align-items: center;
      background-color: #f5f5f5;
      border-radius: 4px;
      > img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
      > span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #575757;
      }
    }
  }
  .record-btn {
    position: fixed;
    left: 50%;
    bottom: 20px;
    z-index: 99;
    transform: translateX(-50%);
    width: 339px;
    height: 46px;
    background-color: #2c66f8;
    border-radius: 3px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
  }
}
</style>
